// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as R404RouteImport } from './routes/404'
import { Route as AerzteRouteImport } from './routes/aerzte'
import { Route as AppRouteRouteImport } from './routes/app/route'
import { Route as BcdRouteImport } from './routes/bcd'
import { Route as DatenschutzerklaerungRouteImport } from './routes/datenschutzerklaerung'
import { Route as FortbildungRouteImport } from './routes/fortbildung'
import { Route as ImpressumRouteImport } from './routes/impressum'
import { Route as KongressrueckblickeRouteImport } from './routes/kongressrueckblicke'
import { Route as LoginRouteImport } from './routes/login'
import { Route as MitgliedschaftRouteImport } from './routes/mitgliedschaft'
import { Route as PatientenRouteImport } from './routes/patienten'
import { Route as SpezialistensucheRouteImport } from './routes/spezialistensuche'
import { Route as SubscriptionRouteImport } from './routes/subscription'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as AppBenutzerkontoRouteImport } from './routes/app/benutzerkonto'
import { Route as AppLeistungenRouteImport } from './routes/app/leistungen'
import { Route as AppMemberFormRouteImport } from './routes/app/member-form'
import { Route as AppMitgliederInfosRouteImport } from './routes/app/mitglieder-infos'
import { Route as AppProtokolleRouteImport } from './routes/app/protokolle'
import { Route as AppRundmailsRouteImport } from './routes/app/rundmails'
import { Route as AppSpezialistensucheRouteImport } from './routes/app/spezialistensuche'
import { Route as PasswordKeyRouteImport } from './routes/password/$key'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const R404Route = R404RouteImport.update({
            id: '/404',path: '/404',getParentRoute: () => rootRouteImport
          })
const AerzteRoute = AerzteRouteImport.update({
            id: '/aerzte',path: '/aerzte',getParentRoute: () => rootRouteImport
          })
const AppRouteRoute = AppRouteRouteImport.update({
            id: '/app',path: '/app',getParentRoute: () => rootRouteImport
          })
const BcdRoute = BcdRouteImport.update({
            id: '/bcd',path: '/bcd',getParentRoute: () => rootRouteImport
          })
const DatenschutzerklaerungRoute = DatenschutzerklaerungRouteImport.update({
            id: '/datenschutzerklaerung',path: '/datenschutzerklaerung',getParentRoute: () => rootRouteImport
          })
const FortbildungRoute = FortbildungRouteImport.update({
            id: '/fortbildung',path: '/fortbildung',getParentRoute: () => rootRouteImport
          })
const ImpressumRoute = ImpressumRouteImport.update({
            id: '/impressum',path: '/impressum',getParentRoute: () => rootRouteImport
          })
const KongressrueckblickeRoute = KongressrueckblickeRouteImport.update({
            id: '/kongressrueckblicke',path: '/kongressrueckblicke',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const MitgliedschaftRoute = MitgliedschaftRouteImport.update({
            id: '/mitgliedschaft',path: '/mitgliedschaft',getParentRoute: () => rootRouteImport
          })
const PatientenRoute = PatientenRouteImport.update({
            id: '/patienten',path: '/patienten',getParentRoute: () => rootRouteImport
          })
const SpezialistensucheRoute = SpezialistensucheRouteImport.update({
            id: '/spezialistensuche',path: '/spezialistensuche',getParentRoute: () => rootRouteImport
          })
const SubscriptionRoute = SubscriptionRouteImport.update({
            id: '/subscription',path: '/subscription',getParentRoute: () => rootRouteImport
          })
const AppIndexRoute = AppIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppRouteRoute
          })
const AppBenutzerkontoRoute = AppBenutzerkontoRouteImport.update({
            id: '/benutzerkonto',path: '/benutzerkonto',getParentRoute: () => AppRouteRoute
          })
const AppLeistungenRoute = AppLeistungenRouteImport.update({
            id: '/leistungen',path: '/leistungen',getParentRoute: () => AppRouteRoute
          })
const AppMemberFormRoute = AppMemberFormRouteImport.update({
            id: '/member-form',path: '/member-form',getParentRoute: () => AppRouteRoute
          })
const AppMitgliederInfosRoute = AppMitgliederInfosRouteImport.update({
            id: '/mitglieder-infos',path: '/mitglieder-infos',getParentRoute: () => AppRouteRoute
          })
const AppProtokolleRoute = AppProtokolleRouteImport.update({
            id: '/protokolle',path: '/protokolle',getParentRoute: () => AppRouteRoute
          })
const AppRundmailsRoute = AppRundmailsRouteImport.update({
            id: '/rundmails',path: '/rundmails',getParentRoute: () => AppRouteRoute
          })
const AppSpezialistensucheRoute = AppSpezialistensucheRouteImport.update({
            id: '/spezialistensuche',path: '/spezialistensuche',getParentRoute: () => AppRouteRoute
          })
const PasswordKeyRoute = PasswordKeyRouteImport.update({
            id: '/password/$key',path: '/password/$key',getParentRoute: () => rootRouteImport
          })





const AppRouteRouteChildren = {
  AppBenutzerkontoRoute: AppBenutzerkontoRoute,AppLeistungenRoute: AppLeistungenRoute,AppMemberFormRoute: AppMemberFormRoute,AppMitgliederInfosRoute: AppMitgliederInfosRoute,AppProtokolleRoute: AppProtokolleRoute,AppRundmailsRoute: AppRundmailsRoute,AppSpezialistensucheRoute: AppSpezialistensucheRoute,AppIndexRoute: AppIndexRoute
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(AppRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AppRouteRoute: AppRouteRouteWithChildren,R404Route: R404Route,AerzteRoute: AerzteRoute,BcdRoute: BcdRoute,DatenschutzerklaerungRoute: DatenschutzerklaerungRoute,FortbildungRoute: FortbildungRoute,ImpressumRoute: ImpressumRoute,KongressrueckblickeRoute: KongressrueckblickeRoute,LoginRoute: LoginRoute,MitgliedschaftRoute: MitgliedschaftRoute,PatientenRoute: PatientenRoute,SpezialistensucheRoute: SpezialistensucheRoute,SubscriptionRoute: SubscriptionRoute,PasswordKeyRoute: PasswordKeyRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)